/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { formatDate } from '@squiz/dxp-console-support';
import { Row } from '@squiz/sds';
import { AI_STRINGS } from 'apps/artificial-intelligence/src/Constants/Strings.constants';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const SemanticAuditorTestSummary = (): JSX.Element => {
  const { t } = useTranslation();
  const labels = {
    dateCreated: t(AI_STRINGS.dateCreated),
    runsIn30Days: t(AI_STRINGS.runsIn30Days),
    totalRuns: t(AI_STRINGS.totalRuns),
  };
  return (
    <Row border={false} classes="semantic-auditor-test-summary">
      <ul className="semantic-auditor-test-summary__list">
        <li>
          <span className="semantic-auditor-test-summary__list-item-name">{labels.runsIn30Days}</span>
          <span className="semantic-auditor-test-summary__list-item-result">{0}</span>
        </li>
        <li>
          <span className="semantic-auditor-test-summary__list-item-name">{labels.totalRuns}</span>
          <span className="semantic-auditor-test-summary__list-item-result">{0}</span>
        </li>
        <li>
          <span className="semantic-auditor-test-summary__list-item-name">{labels.dateCreated}</span>
          <span className="semantic-auditor-test-summary__list-item-result">
            {formatDate('2024-11-06T13:28:00', true)}
          </span>
        </li>
      </ul>
    </Row>
  );
};
